import { memo } from 'react';
import PropTypes from 'prop-types';
import { DynamicImage, useDynamicImage } from '../utils/dynamicImages';

/**
 * Booster-pack card.
 *  • While `shineDisabled` is false it gets `hover:animate-shine`.
 *  • The very first mouse-leave calls `disableShineGlobally()`,
 *    so every card loses the class on the next render.
 */
const BoosterPack = memo(function BoosterPack({
  src,
  className = '',
  alt = 'Card',
  shineDisabled,
  disableShineGlobally,
}) {
  const { src: imageSrc } = useDynamicImage(src);

  return (
    <div
      className="card inline-block h-80 w-60"
      onMouseOver={disableShineGlobally}
    >
      <DynamicImage
        imagePath={src}
        alt={alt}
        className={className}
        loadingComponent={
          <div className={`animate-pulse bg-gray-800 ${className}`}>
            <div className="flex h-full items-center justify-center">
              <span className="text-xs text-gray-400">Loading...</span>
            </div>
          </div>
        }
      />

      <div
        className={`${className} ${shineDisabled ? '' : 'shine-overlay'} absolute inset-0 overflow-hidden ${
          shineDisabled ? '' : 'hover:animate-shine'
        }`}
        style={{
          WebkitMaskImage: imageSrc ? `url(${imageSrc})` : 'none',
          maskImage: imageSrc ? `url(${imageSrc})` : 'none',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
        }}
        onMouseOver={(e) => {
          e.currentTarget.setAttribute('dark', 'false');

          e.currentTarget.parentElement.firstChild.setAttribute('grow', 'true');
          e.currentTarget.parentElement.parentElement.parentElement
            .querySelectorAll('.card')
            .forEach((c) => {
              if (c !== e.currentTarget.parentElement) {
                c.setAttribute('dark', 'true');
              }
            });
        }}
        onMouseLeave={(e) => {
          e.currentTarget.setAttribute('dark', 'false');
          e.currentTarget.parentElement.firstChild.setAttribute(
            'grow',
            'false',
          );
          e.currentTarget.parentElement.parentElement.parentElement
            .querySelectorAll('.card')
            .forEach((c) => {
              c.setAttribute('dark', 'false');
            });
        }}
      />
    </div>
  );
});

BoosterPack.propTypes = {
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
  shineDisabled: PropTypes.bool.isRequired,
  disableShineGlobally: PropTypes.func.isRequired,
};

export default BoosterPack;
